import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getWithdrawRequests } from "../../redux/slices/withdrawSlice";
import { useTranslation } from "react-i18next";
import BackdropSpinner from "../../components/backdropSpinner";

const WithdrawRequest = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const userId = localStorage.getItem("userID");

  // Get data from Redux store
  const { withdrawRequests, loadingRequests } = useSelector(
    (state) => state.withdraw
  );

  useEffect(() => {
    // Ensure userId is available before dispatching the action
    if (userId) {
      dispatch(getWithdrawRequests(userId));
    }
  }, [dispatch, userId]);

  const getStatusClass = (status) => {
    switch (status) {
      case "completed":
        return "bg-green-500"; // Green for completed
      case "failed":
        return "bg-red-500"; // Red for failed
      case "pending":
        return "bg-orange-500"; // Yellow for pending
      case "processed":
        return "bg-blue-500";
      default:
        return "bg-gray-500"; // Default color if status is unknown
    }
  };

  return (
    <div className="flex flex-col items-center justify-center px-2 py-2">
      {/* Title */}
      <div className="flex justify-center my-2">
        <p className="text-white text-lg sm:text-xl md:text-2xl font-medium text-center">
          {t("withdrawRequests.headerTitle")}
        </p>
      </div>

      {/* Table container */}
      <div className="w-full max-w-4xl text-white rounded-lg shadow-lg p-2 mt-2">
        {loadingRequests ? (
          <BackdropSpinner />
        ) : withdrawRequests?.length ? (
          <table className="w-full border-collapse border border-[#E7B76A]">
            <thead>
              <tr className="bg-gradient-to-r text-black from-[#C38B20] to-[#E5AA36] text-left">
                <th className="p-2 border border-[#E7B76A]">
                  {t("withdrawRequests.requestDate")}
                </th>
                <th className="p-2 border border-[#E7B76A]">
                  {t("withdrawRequests.amount")}
                </th>
                <th className="p-2 border border-[#E7B76A]">
                  {t("withdrawRequests.status")}
                </th>
              </tr>
            </thead>
            <tbody>
              {withdrawRequests.map((request) => (
                <tr key={request.id}>
                  <td className="p-2 border border-[#E7B76A]">
                    {new Date(request.request_date).toLocaleDateString("en-GB")}
                  </td>
                  <td className="p-2 border border-[#E7B76A]">{request.amount}</td>
                  <td className="p-2 border border-[#E7B76A]">
                    <span
                      className={`px-3 py-2 rounded-full text-white text-sm ${getStatusClass(request.status)}`}
                    >
                      {t(`withdrawRequests.statuses.${request.status}`)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="text-center text-gray-400">
            {t("withdrawRequests.noData")}
          </div>
        )}
      </div>
    </div>
  );
};

export default WithdrawRequest;
